import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals, { sendToAnalytics } from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { initAnalytics } from "./utils/analyticsInit";

import { Provider } from "react-redux";
import store, { persistor } from "./Redux/store";
import { PersistGate } from 'redux-persist/integration/react';
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
const GOOGLE_CLIENT_ID = `630351693464-egrkc0id97ijks42ampd1m1p41ro2mrb.apps.googleusercontent.com`;
console.log("GOOGLE_CLIENT_ID", GOOGLE_CLIENT_ID);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <App />
        </GoogleOAuthProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

initAnalytics();
reportWebVitals(sendToAnalytics);
